<p-popover
    #changeRequestPopover
    appendTo="body"
    [dismissable]="true"
    [style]="{ width: '24rem', maxWidth: 'calc(100vw - 1rem)' }"
    styleClass="change-request-details-popover"
>
    <div class="flex flex-col st-border">
        <p-table
            [value]="changeRequestDetails"
            class="w-full"
            [scrollable]="true"
            scrollHeight="20rem"
        >
            <ng-template #caption>
                <div class="flex justify-between items-center h-full w-full">
                    <div class="font-bold">Change Request Details</div>
                    <p-button
                        icon="pi pi-times"
                        [rounded]="true"
                        [text]="true"
                        severity="secondary"
                        size="small"
                        pTooltip="Close"
                        [showDelay]="500"
                        (onClick)="close()"
                    />
                </div>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td class="font-bold pr-6 whitespace-nowrap">{{ rowData.field }}</td>
                    <td class="w-full overflow-hidden max-w-0 whitespace-nowrap text-ellipsis">
                        {{ rowData.value }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-popover>
